const SelectNonForm = ({ name, option = [], defaultValue, value, id, onChange }) => {
    return (
      <select
        className="form-control"
        name={name}
        defaultValue={defaultValue}
        value={value}
        id={id}
        onChange={onChange}
        style={{
          background: 'blue',
          borderColor: 'rgba(0,0,0,.24)',
          color: 'white',
          width: '100%',
          appearance: 'auto',
        }}
      >
        {option.map((key, index) => (
          <option
            key={index}
            value={key.id}
            disabled={key.id === '' ? true : false}
            selected={key.id === '' ? true : false}
          >
            {key.name}
          </option>
        ))}
      </select>
    )
  }

const Input = ({ props, onChange, type, name, id, value, validation }) => {
  return (
    <input
      onChange={onChange}
      type={type}
      name={name}
      id={id}
      className="form-control"
      style={{
        background: 'white',
        borderColor:
          validation.touched && validation.errors
            ? 'red'
            : 'rgba(0,0,0,.24)',
        color: 'black',
        width: '100%',
      }}
      value={value}
      {...props}
    />
  )
}

const InputNonForm = ({ props, onChange, className, type, name, id, value }) => {
  return (
    <input
      onChange={onChange}
      type={type}
      name={name}
      id={id}
      className={className}
      style={{
        background: 'blue',
        borderColor: 'rgba(0,0,0,.24)',
        color: 'white',
        width: '100%',
      }}
      value={value}
      {...props}
    />
  )
}

const SelectInput = ({ name, option = [], defaultValue, value, id, onChange, validation }) => {
  return (
    <select
      className="form-control"
      name={name}
      defaultValue={defaultValue}
      value={value}
      id={id}
      onChange={onChange}
      style={{
        background: 'white',
        borderColor:
          validation.touched && validation.errors
            ? 'red'
            : 'rgba(0,0,0,.24)',
        color: 'black',
        width: '100%',
        appearance: 'auto',
      }}
    >
      {option.map((key, index) => (
          <option
            key={index}
            value={key.id}
            disabled={key.id === '' ? true : false}
            selected={key.id === '' ? true : false}
          >
            {key.name}
          </option>
        ))}
    </select>
  )
}

const InputDropdown = ({ name, option = [], defaultValue, value, id, onChange, validation }) => {
  return (
    <select
      className="form-control"
      name={name}
      defaultValue={defaultValue}
      value={value}
      id={id}
      onChange={onChange}
      style={{
        background: 'white',
        borderColor:
          validation.touched && validation.errors
            ? 'red'
            : 'rgba(0,0,0,.24)',
        color:  'black',
        width: '100%',
        appearance: 'auto',
      }}
    >
      {option.map((key, index) => (
        <option key={index} value={key.id} disabled={key.id === '' ? true : false}>
          {key.name}
        </option>
      ))}
    </select>
  )
}

const TextArea = ({ props, onChange, name, id, value, validation }) => {
  return (
    <textarea
      autoComplete="off"
      onChange={onChange}
      id={id}
      className="form-control"
      rows="3"
      name={name}
      cols="50"
      value={value}
      style={{
        background: 'white',
        borderColor:
          validation.touched && validation.errors
            ? 'red'
            : 'rgba(0,0,0,.24)',
        color: 'black',
        width: '100%',
      }}
      {...props}
    ></textarea>
  )
}

const SelectSearch = ({ data, onChange, name, value, changeField, validation }) => {
  return (
    <select
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          background: 'white',
          borderColor:
            validation.touched && validation.errors
              ? 'red'
              : 'rgba(0,0,0,.24)',
          width: '100%',
          appearance: 'auto',
        }),
        singleValue: (provided, state) => ({
          ...provided,
          color: state.isSelected ? ('white') : 'white',
          // specify a fallback color here for those values not accounted for in the styleMap
        }),
        input: (inputs, state) => ({
          ...inputs,
          color: 'rgba(0,0,0,.24)',
        }),
      }}
      onChange={onChange}
      name={name}
      id={name}
      value={value}
      options={data}
    />
  )
}

export { 
  SelectNonForm, 
  InputNonForm, 
  Input, 
  SelectInput, 
  InputDropdown, 
  TextArea,
  SelectSearch 
}